<div class="modal-header">
	<h4 class="modal-title">Lisää tiedostoja</h4>
	<button
		type="button"
		class="btn-close"
		aria-label="Close"
		(click)="activeModal.dismiss()"
	></button>
</div>
<div class="modal-body">
	<div
		class="upload-container"
		[class.drag-active]="isDragActive"
		(dragover)="onDragOver($event)"
		(dragleave)="onDragLeave($event)"
		(drop)="onDrop($event)"
	>
		<div class="upload-instructions">
			<div class="text-center mb-4">
				<i class="bi bi-cloud-arrow-up-fill upload-icon"></i>
				<h5 class="mt-2">Vedä ja pudota tiedostoja tähän</h5>
				<p>tai käytä alla olevia vaihtoehtoja</p>
			</div>

			<div class="upload-options">
				<button
					class="btn btn-primary me-2"
					(click)="triggerFileInput()"
				>
					<i class="bi bi-folder"></i> Valitse tiedostot
				</button>
				<button
					class="btn btn-primary"
					(click)="openUrlModal()"
				>
					<i class="bi bi-file-earmark-arrow-down"></i> Syötä
					verkkosivu tai tekstiä...
				</button>
			</div>

			<input
				#fileInput
				type="file"
				multiple
				style="display: none"
				(change)="onFileSelected($event)"
			/>
		</div>

		<!-- Commented out old tag functionality - keeping code for potential future use -->
		<!-- <div class="tags-section mt-4">
			<h5>Tagit</h5>

			<div
				class="existing-tags-section mb-3"
				*ngIf="
					sourceMaterialService.Tags &&
					sourceMaterialService.Tags.length > 0
				"
			>
				<div class="existing-tags-list">
					<span
						*ngFor="let tag of sourceMaterialService.Tags"
						class="badge bg-light text-dark me-2 mb-2 existing-tag"
						[class.selected]="selectedTagIds.includes(tag.id)"
						(click)="addExistingTag(tag.name)"
						role="button"
						tabindex="0"
						[attr.aria-label]="'Lisää tagi: ' + tag.name"
					>
						{{ tag.name }}
						<i
							class="bi bi-plus-circle ms-1"
							*ngIf="!selectedTagIds.includes(tag.id)"
						></i>
						<i
							class="bi bi-check-circle ms-1"
							*ngIf="selectedTagIds.includes(tag.id)"
						></i>
					</span>
				</div>
			</div>

			<div class="tag-input-container">
				<div class="tags-display mb-2">
					<span
						*ngFor="let tagId of selectedTagIds"
						class="badge badge-pill bg-secondary me-2 mb-2"
					>
						{{
							sourceMaterialService.GetTagById(tagId)?.name ||
								"Unknown Tag"
						}}
						<button
							type="button"
							class="btn-close btn-close-white btn-sm ms-1"
							aria-label="Remove tag"
							(click)="removeTag(tagId)"
							style="font-size: 0.7rem"
						></button>
					</span>
				</div>
				<div class="input-group">
					<input
						type="text"
						class="form-control"
						placeholder="Lisää tagi ja paina Enter..."
						[(ngModel)]="currentTagInput"
						(keyup.enter)="addTag()"
					/>
					<button
						class="btn btn-outline-primary btn-padding"
						type="button"
						(click)="addTag()"
					>
						<i class="bi bi-plus"></i> Lisää
					</button>
				</div>
				<small class="form-text text-muted">
					Nämä tagit lisätään kaikkiin ladattaviin tiedostoihin
				</small>
				<div class="mt-2">
					<button
						class="btn btn-primary btn-padding"
						type="button"
						(click)="applyTagsToAllItems()"
						[disabled]="
							isUploading ||
							uploadItems.length === 0 ||
							selectedTagIds.length === 0
						"
					>
						Päivitä tagit kaikkiin latauksiin
					</button>
				</div>
			</div>
		</div> -->

		<div *ngIf="uploadItems.length > 0" class="upload-queue mt-4">
			<div class="d-flex justify-content-between align-items-center mb-3">
				<h5 class="mb-0">
					Tiedostot
					<span class="badge bg-secondary ms-2"
						>{{ uploadItems.length }} kpl</span
					>
				</h5>
			</div>
			<!-- <div class="mb-3">
				<span class="text-success">
					<i class="bi bi-check-circle me-1"></i>
					Valmiit: {{ getCompletedCount() }}
				</span>
				<span class="text-primary ms-3">
					<i class="bi bi-hourglass-split me-1"></i>
					Käynnissä: {{ getUploadingCount() }}
				</span>
				<span class="text-danger ms-3" *ngIf="getFailedCount() > 0">
					<i class="bi bi-exclamation-circle me-1"></i>
					Virheet: {{ getFailedCount() }}
				</span>
			</div> -->
			<div class="file-list">
				<div *ngFor="let item of uploadItems" class="file-item mb-3">
					<div class="d-flex align-items-center">
						<div class="status-icon" [ngSwitch]="item.status">
							<i *ngSwitchCase="'pending'" class="bi bi-hourglass text-muted"></i>
							<i *ngSwitchCase="'uploading'" class="bi bi-cloud-upload text-primary"></i>
							<i *ngSwitchCase="'completed'" class="bi bi-check2 text-success"></i>
							<i *ngSwitchCase="'failed'" class="bi bi-x text-danger"></i>
						</div>
						<div class="file-info flex-grow-1 ms-2">
							<div class="d-flex justify-content-between">
								<span class="file-name">{{
									item.file.name
								}}</span>
								<span class="file-size">{{
									formatFileSize(item.file.size)
								}}</span>
							</div>

							<ngb-progressbar
								[value]="
									item.progress === 0 ? 100 : item.progress
								"
								[max]="100"
								[type]="
									item.status === 'completed'
										? 'success'
										: item.status === 'failed'
											? 'danger'
											: item.status === 'pending'
												? 'warning'
												: 'primary'
								"
								[striped]="
									item.status !== 'completed' &&
									item.status !== 'failed'
								"
								[animated]="
									item.status !== 'completed' &&
									item.status !== 'failed'
								"
								class="mt-1"
							>
							</ngb-progressbar>

							<div class="status-text small mt-1">
								<span
									*ngIf="item.status === 'pending'"
									class="text-muted"
								>
									Odottaa lataamista...
								</span>
								<span
									*ngIf="item.status === 'uploading'"
									class="text-muted"
								>
									{{
										item.statusMessage ||
											"Lähetetään tiedostoa..."
									}}
								</span>
								<span
									*ngIf="item.status === 'completed'"
									class="text-muted"
								>
									Lataus valmis.
								</span>
							</div>

							<div
								*ngIf="item.status === 'failed'"
								class="small text-muted"
							>
								<span *ngIf="!item.validationFailed">
									{{ item.error || "Lataus epäonnistui." }}
								</span>
								<span *ngIf="item.validationFailed">
									{{ item.error }}
								</span>
								<div
									class="mt-1"
									*ngIf="!item.validationFailed"
								>
									<button
										type="button"
										class="btn btn-secondary me-1"
										(click)="retryUpload(item)"
									>
										<i class="bi bi-arrow-clockwise"></i>
										Yritä uudelleen
									</button>
									<button
										type="button"
										class="btn btn-secondary"
										(click)="cancelUpload(item)"
									>
										<i class="bi bi-x"></i> Peruuta
									</button>
								</div>
								<div class="mt-1" *ngIf="item.validationFailed">
									<button
										type="button"
										class="btn btn-sm btn-outline-primary me-1"
										*ngIf="item.validationFailed"
										(click)="
											overrideValidationAndUpload(item)
										"
									>
										<i
											class="bi bi-file-earmark-arrow-up"
										></i>
										Jatka lataamista
									</button>
									<button
										type="button"
										class="btn btn-secondary"
										(click)="cancelUpload(item)"
									>
										<i class="bi bi-x"></i> Peruuta
									</button>
								</div>
							</div>
						</div>
						<div class="actions ms-2">
							<!-- URL extraction button -->
							<button
								*ngIf="canExtractImagesFromURL(item)"
								type="button"
								class="btn btn-link text-secondary"
								(click)="openURLImageExtractor(item)"
								title="Poimi kuvat verkkosivulta"
							>
								<i class="bi bi-images"></i>
							</button>

							<!-- PDF extraction button -->
							<button
								*ngIf="
									!canExtractImagesFromURL(item) &&
									canExtractImagesFromPDF(item)
								"
								type="button"
								class="btn btn-link text-secondary"
								(click)="openPDFImageExtractor(item)"
								title="Poimi kuvat PDF-tiedostosta"
							>
								<i class="bi bi-images"></i>
							</button>

							<!-- Tags button -->
							<button
								*ngIf="item.status === 'completed'"
								type="button"
								class="btn btn-link text-secondary"
								(click)="openAddTagsModal(item)"
								title="Lisää tageja tähän tiedostoon"
							>
								<i class="bi bi-tags"></i>
							</button>

							<button
								*ngIf="item.status === 'pending'"
								type="button"
								class="btn btn-link text-secondary"
								(click)="removeItem(item)"
							>
								<i class="bi bi-x"></i>
							</button>
							<button
								*ngIf="item.status === 'uploading'"
								type="button"
								class="btn btn-link text-secondary"
								(click)="cancelUpload(item)"
							>
								<i class="bi bi-x"></i>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div *ngIf="isProcessingClipboard" class="clipboard-processing">
			<div class="spinner-border text-primary" role="status">
				<span class="visually-hidden">Käsitellään leikepöytää...</span>
			</div>
			<span class="ms-2">Käsitellään leikepöytää...</span>
		</div>

		<div *ngIf="isProcessingUrl" class="url-processing">
			<div class="spinner-border text-primary" role="status">
				<span class="visually-hidden">Haetaan URL-osoitetta...</span>
			</div>
			<span class="ms-2">Haetaan URL-osoitetta...</span>
		</div>
	</div>
</div>

<div class="modal-footer">
	<div class="d-flex justify-content-between w-100">
		<div></div>
		<div>
			<!-- <button type="button" class="btn btn-outline-secondary me-2" (click)="activeModal.close()">
        Peruuta
      </button> -->
			<button
				type="button"
				class="btn btn-secondary"
				[disabled]="isUploading"
				(click)="finishUpload()"
			>
				{{ isUploading ? "Ladataan..." : "Sulje" }}
			</button>
		</div>
	</div>
</div>

<!-- URL Input Modal Template -->
<ng-template #urlInputModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Syötä verkkosivu tai tekstiä</h4>
		<button
			type="button"
			class="btn-close"
			aria-label="Close"
			(click)="modal.dismiss()"
		></button>
	</div>
	<div class="modal-body">
		<div class="form-group">
			<label for="urlInput" class="form-label"
				>Syötä verkkosivun osoite tai vapaamuotoinen teksti
			</label>
			<input
				#urlInputField
				id="urlInput"
				type="text"
				class="form-control"
				placeholder="https://example.com"
				[(ngModel)]="pasteInputValue"
				(keyup.enter)="processUrlFromModal(modal)"
			/>
			<!-- <small class="form-text text-muted mt-2"
				>Voit syöttää URL-osoitteen tai vapaan tekstin</small
			> -->
		</div>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn btn-secondary"
			(click)="modal.dismiss()"
		>
			Peruuta
		</button>
		<button
			type="button"
			class="btn btn-primary"
			(click)="processUrlFromModal(modal)"
			[disabled]="!pasteInputValue.trim()"
		>
			<i class="bi bi-download"></i> Hae sisältö
		</button>
	</div>
</ng-template>
